import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { AssetPipe } from '@shared/asset/asset.pipe';
import { DisabledScrollDirective } from '@shared/disable-scroll/disabled-scroll.directive';
import { ModalService } from '@shared/modal/modal.service';

@Component({
    selector: 'companyid-modal',
    imports: [NgOptimizedImage, AssetPipe, DisabledScrollDirective],
    templateUrl: './modal.component.html',
    styleUrl: './modal.component.scss',
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent {
    private readonly modalService = inject(ModalService);

    public readonly type = this.modalService.type;
    public readonly isOpened = this.modalService.isOpened;

    public closeModal(): void {
        this.modalService.close();
    }
}
